/* Older customer auth flow retained alongside spAuthCof (login/register/OTP/password).
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";
const CryptoJS = require("crypto-js");

export default {
  methods: {

    //Token implemented
    show_account() {
      this.AccountActiveDeactiveDiv = false;
      this.resultsMobile = {};
      this.cardSkeletonLoader = false;
      this.deleteCardConfirmationDialog = false;
      this.deleteConfirmationCard = false;
      this.saved_card_list = false;
      this.saved_card_tab1 = false;
      this.cards_selected_gateway_iddd = 0;
      this.mfs_selected_gateway_iddd = 0;
      this.ibanking_selected_gateway_iddd = 0;

      this.cof_pay_now_btn_label = "Pay Now";
      this.saved_card_paynow_label = "Pay Now";
      this.isFormValid2 = false;
      this.selectedCvvIndex = null;

      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;
      this.loginOTP = ['', '', '', '', '', ''];


      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.card_tab = false;
              this.mobile_banking = false;
              this.i_banking = false;
              this.loading_tab = false;
              this.loading_dialog = false;
              this.saved_card_tab1 = false;
              this.signup_div = false;
              this.user_account = true;
              this.login_div = true;

              this.tdr_visibility = 0;
              this.tdr_visibility_pay_now_btn = 0;
              this.normal_user = 1;
              this.payable_amt = 0;

              if (this.myaccount == true) {
                this.login_div = false;
                this.myaccount = true;
              }
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //card-holder-login check api
    login_status() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.login_status_pre();
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    login_status_pre() {
      let check_login_val = this.$refs.form5.validate();

      if (this.resultsMobile["isValid"]) {
        if (check_login_val) {
          var countryCode = this.resultsMobile["countryCode"];
          var formattedNumber = this.resultsMobile["formattedNumber"];

          var token = this.$route.query.token;
          this.loginItem.login_mobile_number = formattedNumber;
          var mobile_no = formattedNumber;
          var password_real = this.loginItem.login_password;

          var CryptoJSAesJson = {
            stringify: function(cipherParams) {
              var j = {
                ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
              };
              if (cipherParams.iv) j.iv = cipherParams.iv.toString();
              if (cipherParams.salt) j.s = cipherParams.salt.toString();
              return JSON.stringify(j);
            },
          };

          var key = this.$route.query.order_id;
          var orderid = this.$route.query.order_id;
          var password = CryptoJS.AES.encrypt(
            JSON.stringify(password_real),
            key,
            { format: CryptoJSAesJson }
          ).toString();

          const options = {
            method: "POST",
            url: this.customer_api_base_url + "customer-login",
            headers: {
              Authorization: "Bearer " + token,
            },
            data: {
              mobile_no,
              password,
              countryCode,
              orderid,
            },
          };

          axios
            .request(options)
            .then((response) => {
              //When the user is active and successful login
              if (
                response.data.is_active == 1 &&
                response.data.sp_code == "200"
              ) {
                this.customer_name = response.data.customer_name;
                this.login_div = false;
                this.myaccount = true;
                this.no_login = false;
                this.loginBool = 1;

                //Set cookie information
                var cookie_name = "token";
                var cookie_value = response.data.token;
                var exipry_from_token = response.data.expires_in;
                let date = new Date();
                date.setTime(date.getTime() + exipry_from_token * 1000);
                let cookie_time = "expires=" + date.toUTCString();
                document.cookie =
                  cookie_name + "=" + cookie_value + "; " + cookie_time + "; ";

                //Reset login form data
                this.loginItem.login_mobile_number = "";
                this.loginItem.login_password = "";

                //After login fetch saved card list (if any)
                this.cardList = "";
                var customer_token = this.getCookie("token");

                if (customer_token !== "") {
                  const options = {
                    method: "GET",
                    url: this.customer_api_base_url + "show-card-info-list",
                    headers: {
                      Authorization: "Bearer " + customer_token,
                    },
                  };

                  axios
                    .request(options)
                    .then((response) => {
                      if (response.data.sp_code == "200") {
                        this.cardList = response.data.card_data;
                        this.isShowStaticPart = true;

                        //After login redirect tab decision
                        if (this.isCard == 1) {
                          this.active_tab = "cards";
                          this.show_cards(1);
                        }

                        if (this.isCard == 0 && this.isMbanking == 2) {
                          this.active_tab = "mfs";
                          this.show_mbanking();
                        }

                        if (
                          this.isCard == 0 &&
                          this.isMbanking == 0 &&
                          this.isIBanking == 3
                        ) {
                          this.active_tab = "ibanking";
                          this.show_ibanking();
                        }
                      } else {
                        this.isShowStaticPart = false;

                        //After login redirect tab decision
                        if (this.isCard == 1) {
                          this.active_tab = "cards";
                          this.show_cards(1);
                        }

                        if (this.isCard == 0 && this.isMbanking == 2) {
                          this.active_tab = "mfs";
                          this.show_mbanking();
                        }

                        if (
                          this.isCard == 0 &&
                          this.isMbanking == 0 &&
                          this.isIBanking == 3
                        ) {
                          this.active_tab = "ibanking";
                          this.show_ibanking();
                        }
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                } else {
                  //After login redirect tab decision
                  if (this.isCard == 1) {
                    this.active_tab = "cards";
                    this.show_cards(1);
                  }

                  if (this.isCard == 0 && this.isMbanking == 2) {
                    this.active_tab = "mfs";
                    this.show_mbanking();
                  }

                  if (
                    this.isCard == 0 &&
                    this.isMbanking == 0 &&
                    this.isIBanking == 3
                  ) {
                    this.active_tab = "ibanking";
                    this.show_ibanking();
                  }
                }
              }

              //Password not matched
              else if (response.data.sp_code == "1064") {
                this.snackbar = true;
                this.color = "error";
                this.timeout = 6000;
                this.popup_text = response.data.message;
              }

              //No such account exist,Wrong Mobile number
              else if (response.data.sp_code == "102") {
                this.snackbar = true;
                this.color = "error";
                this.timeout = 6000;
                this.popup_text = response.data.message;
              }

              //Account is not active popup account active modal
              else if (
                response.data.is_active == 0 &&
                response.data.sp_code == "200"
              ) {
                this.login_div = true;
                this.active_acc_otp = true;
                this.display_resend_otp_text = true;
                this.dispaly_time_otp = false;
                this.active_account_mobile = formattedNumber;
              }
            })
            .catch((error) => {
              console.log(error);
              this.snackbar = true;
              this.color = "red";
              this.popup_text = "Something went wrong...";
            });
        } else {
          this.snackbar = true;
          this.color = "error";
          this.timeout = 2000;
          this.popup_text = "Please provide password field";
        }
      } else {
        this.snackbar = true;
        this.color = "error";
        this.timeout = 2000;
        this.popup_text = "Mobile number is not valid";
      }
    },

    getCookie(cname) {
      let name = cname + "=";
      let spli = document.cookie.split(";");
      for (var j = 0; j < spli.length; j++) {
        let char = spli[j];
        while (char.charAt(0) == " ") {
          char = char.substring(1);
        }
        if (char.indexOf(name) == 0) {
          return char.substring(name.length, char.length);
        }
      }
      return "";
    },

    //checked during mounted
    check_card_holder_login() {
      var customer_token = this.getCookie("token");

      if (customer_token !== "") {
        //console.log("Token has value");
        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-token-check",
          headers: {
            Authorization: "Bearer " + customer_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.login_div = false;
              this.myaccount = true;
              this.no_login = false;
              this.customer_name = response.data.customer_name;
              this.loginBool = 1;
            } else {
              this.login_div = true;
              this.myaccount = false;
              this.no_login = true;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //token applied
    register() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.register_pre();
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    register_pre() {
      let signup_val = this.$refs.form_register.validate();

      if (this.resultsMobile["isValid"]) {
        if (signup_val) {
          var countryCode = this.resultsMobile["countryCode"];
          var formattedNumber = this.resultsMobile["formattedNumber"];

          var email = this.signup_items.email_address;
          var token = this.$route.query.token;
          var name = this.signup_items.fullname;
          var password = this.signup_items.password;
          var password_confirmation = password;
          // var mobile_no = this.signup_items.mobile_number;
          this.signup_items.mobile_number = formattedNumber;
          var mobile_no = formattedNumber;

          const options = {
            method: "POST",
            url: this.customer_api_base_url + "customer-sign-up",
            headers: {
              Authorization: "Bearer " + token,
            },
            data: {
              name,
              email,
              password,
              password_confirmation,
              mobile_no,
              countryCode,
            },
          };
          axios
            .request(options)
            .then((response) => {
              if (response.data.sp_code == "200") {
                this.signup_div = false;
                this.login_div = true;
                this.resigtration_otp = true;
                // var inputed_mobile = this.signup_items.mobile_number;
                this.signup_items.mobile_number = formattedNumber;
                var inputed_mobile = formattedNumber;
                this.resigter_otp_text = inputed_mobile;
                this.showRemaining(3);
              } else {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 7000;
                this.popup_text = response.data.message;
              }
            })
            .catch((error) => {
              console.log(error);
              this.snackbar = true;
              this.color = "red";
              this.timeout = 6000;
              this.popup_text = "Something went wrong...";
            });
        } else {
          this.snackbar = true;
          this.color = "red";
          this.timeout = 2000;
          this.popup_text = "Provide required fields value";
        }
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Mobile Number is not valid";
      }
    },

    //token applied self
    register_otp_confirm() {
      let check_otp_varification = this.$refs.register_otpp.validate();
      if (check_otp_varification) {
        var token = this.$route.query.token;
        var mobile_no = this.signup_items.mobile_number;
        var verify_code = this.resigter_otp;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-verify-account",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            mobile_no,
            verify_code,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
              this.snackbar = true;
              this.color = "#0F9750";
              this.popup_text = response.data.message;
              this.login_div = true;
              this.signup_div = false;
              this.resigtration_otp = false;

              //Reset sign up form
              this.signup_items.email_address = "";
              this.signup_items.fullname = "";
              this.signup_items.password = "";
              this.signup_items.mobile_number = "";
            } else {
              this.snackbar = true;
              this.color = "red";
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //token applied
    close_reg_otp_modal() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.signup_div = true;
              this.login_div = false;
              this.resigtration_otp = false;
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //token applied self
    resend_otp() {
      var token = this.$route.query.token;
      var mobile_no = this.signup_items.mobile_number;
      const options = {
        method: "POST",
        url: this.customer_api_base_url + "customer-resend-code",
        headers: {
          Authorization: "Bearer " + token,
        },
        data: {
          mobile_no,
        },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data.sp_code == "200") {
            this.snackbar = true;
            this.color = "success";
            this.timeout = 7000;
            this.popup_text =
              "Another OTP sent to " + this.signup_items.mobile_number;

            this.login_div = true;
            this.signup_div = false;

            this.resigtration_otp = true;
            this.dispaly_time_otp = true;
            this.display_resend_otp_text = false;
            this.showRemaining(3);
          } else {
            this.snackbar = true;
            this.color = "red";
            this.popup_text = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //later
    cancel_btn() {
      // var token = this.$route.query.token;
      // var orderid = this.$route.query.order_id;
      // const options = {
      //   method: 'POST',
      //   url: this.base_url+'cancle',
      //   headers: {
      //     Authorization: 'Bearer '+token
      //   },
      //   data:{
      //     orderid
      //   },
      // };
      // axios.request(options).then(response =>{

      //   if(response.data.message == 1){
      //       window.location.href = response.data.url;
      //   }

      //   else{
      //     this.snackbar = true;
      //     this.color = "red";
      //     this.popup_text = "Something went wrong...";
      //    }
      // }).catch(error =>{
      //   console.log(error);
      // });

      this.saved_card_tab1 = true;
      this.card_tab = false;
    },

    //token applied
    show_singup_form() {
      this.resultsMobile = {};

      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.login_div = false;
              this.signup_div = true;
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //no need --never used
    show_login_form() {
      this.login_div = true;
      this.signup_div = false;
    },

    //token applied
    forgot_password() {
      this.resultsMobile = {};

      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.forgot_password_modal = true;
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //token applied
    send_otp() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.send_otp_pre();
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    send_otp_pre() {
      //let isValid = this.$refs.form2.validate();
      let isValid = this.resultsMobile["isValid"];

      if (isValid) {
        var countryCode = this.resultsMobile["countryCode"];
        var formattedNumber = this.resultsMobile["formattedNumber"];

        //var mobile_no = this.forgot_password_mobile;
        this.forgot_password_mobile = formattedNumber;
        var mobile_no = formattedNumber;
        var token_check = this.$route.query.token;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-forgot-pass",
          headers: {
            Authorization: "Bearer " + token_check,
          },
          data: {
            mobile_no,
            countryCode,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.forgot_password_modal = false;
              this.forgot_password_otp_modal = true;

              // var inputed_mobile = this.forgot_password_mobile;
              var inputed_mobile = formattedNumber;
              this.otp_send_text_msg = inputed_mobile;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Mobile number is not valid";
      }
    },

    //token applied self
    send_active_otp() {
      let isValid = this.$refs.form22.validate();
      if (isValid) {
        var mobile_no = this.active_account_mobile;
        var token_check = this.$route.query.token;
        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-verify-account",
          headers: {
            Authorization: "Bearer " + token_check,
          },
          data: {
            mobile_no,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
              //this.active_account_modal=false;
              //this.active_acc_otp=true;
              //var inputed_mobile = this.active_account_mobile;
              // var f_part = inputed_mobile.substring(0,3);
              // var first_part = inputed_mobile.substring(3, 9);
              // var hidden_part = first_part.replace(/[0-9]/g, "*");
              // var normal_part = inputed_mobile.substring(9, 11);
              // this.active_account_otp_input_text = inputed_mobile;

              this.active_acc_otp = false;
              this.login_div = true;
              this.signup_div = false;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //token applied self
    active_otp_confirm() {
      let check_otp_varification = this.$refs.active_otpp.validate();

      if (check_otp_varification) {
        var token = this.$route.query.token;
        var mobile_no = this.active_account_mobile;
        var verify_code = this.active_account_otp_input;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-verify-account",

          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            mobile_no,
            verify_code,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
              this.snackbar = true;
              this.color = "#0F9750";
              this.timeout = 8000;
              this.popup_text = "Account Activation successful.";

              this.login_div = true;
              this.signup_div = false;
              this.active_acc_otp = false;
              this.loginItem.login_mobile_number = "";
              this.loginItem.login_password = "";
            } else {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 4000;
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Enter Your OTP From SMS";
      }
    },

    //token applied
    send_otp_back() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.forgot_password_modal = false;
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //Applied via self called
    submit_otp() {
      let isValid = this.$refs.form_otp.validate();
      if (isValid) {
        var token = this.$route.query.token;
        var verify_code = this.forgot_password_otp;
        var mobile_no = this.forgot_password_mobile;
        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-verify-account",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            verify_code,
            mobile_no,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
              this.forgot_password_otp_modal = false;
              this.forgot_password_modal = false;
              this.new_password_modal = true;
              this.reset_password_mobile = mobile_no;
            } else if (response.data.sp_code == "101") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 3000;
              this.popup_text = "OTP does not matched";
              this.reset_password_mobile = mobile_no;
            } else if (response.data.sp_code == "103") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.reset_password_mobile = mobile_no;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.reset_password_mobile = mobile_no;
            }
          })
          .catch((error) => {
            console.log(error);
            this.reset_password_mobile = mobile_no;
          });
      }
    },

    //token applied
    submit_otp_back() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.forgot_password_otp_modal = false;
              this.forgot_password_modal = false;
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //token applied by self
    resetPassword() {
      let checkVal = this.$refs.form_password_reset.validate();
      if (checkVal) {
        var token = this.$route.query.token;
        var mobile_no = this.reset_password_mobile;
        var c_password = this.confirmed_new_password;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-new-pass-set",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            mobile_no,
            c_password,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.forgot_password_otp_modal = false;
              this.forgot_password_modal = false;
              this.new_password_modal = false;
              //mominur

              this.signup_div = false;
              this.user_account = true;
              this.login_div = true;

              this.snackbar = true;
              this.color = "primary";
              this.timeout = 3000;
              this.popup_text = "Your password has been changed successfully.";
            } else {
              this.snackbar = true;
              this.color = "primary";
              this.timeout = 3000;
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
            this.$refs.form2.reset();
          });
      }
    },

    //token applied
    resetPassword_back() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.new_password_modal = false;
              this.forgot_password_otp_modal = false;
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    logout_user() {
      var customer_login_cookie = this.getCookie("token");

      if (customer_login_cookie !== "") {
        var cookie_name = "token";
        var cookie_value = "";
        let date = new Date();
        date.setTime(date.getTime() - 2 * 1000);
        let cookie_time = "expires=" + date.toUTCString();
        document.cookie =
          cookie_name + "=" + cookie_value + "; " + cookie_time + "; ";

        this.loginBool = 0;
        this.cardList = "";

        this.myaccount = false;
        this.no_login = true;
        this.login_div = true;

        this.isShowStaticPart = false;

        // New changes
        // 29/08/2022

        if (this.logout_tab_decision == "1") {
          this.active_tab = "cards";
          this.show_cards(1);
        }

        if (this.logout_tab_decision == "2") {
          this.active_tab = "mfs";
          this.show_mbanking();
        }

        if (this.logout_tab_decision == "3") {
          this.active_tab = "ibanking";
          this.show_ibanking();
        }

        if (this.logout_tab_decision == "4") {
          this.active_tab = "account";
          this.show_account();
        }
      } else {
        this.snackbar = true;
        this.color = "error";
        this.timeout = 2000;
        this.popup_text = "No Cookie Exists";
      }
    },
  },
};
